import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { CloudUpload } from "@material-ui/icons";
import { FileUploader } from "react-drag-drop-files";
import Select from "react-select";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class UploadAdjustment extends Component {
  constructor(props) {
    super();
    this.state = {
      showAddModal: false,
      showCheckModal: false,
      showSuccessModal: false,
      companyDD: [],
      hasError: false,
      hasWarning: false,
      disableAdd: false,
      checkData: [],
      err_no: 0,
      rec_no: 0,
    };
    this.handleshowAddModal = this.handleshowAddModal.bind(this);
  }

  handleshowAddModal = (e) => {
    this.setState({
      showAddModal: !this.state.showAddModal,
      disableAdd: false,
      hasError: false,
      hasWarning: false,
      actual_file: null,
      file_name: null,
    });
  };

  handleshowCheckModal = (e) => {
    this.setState({
      showCheckModal: !this.state.showCheckModal,
    });
  };

  handleCheck = (e) => {
    e.preventDefault();
    // this.setState({ disableAdd: true });
    let formData = new FormData();
    formData.append("uploadFile", this.state.actual_file);
    formData.append("file_name", this.state.file_name);
    formData.append("description", this.state.description);
    formData.append("record_year", this.state.record_year);
    formData.append("company_id", cookies.get("transCompany"));
    formData.append("updated_by", cookies.get("email"));
    formData.append("created_by", cookies.get("email"));

    axios.post("api/add_upload_adjustment_check", formData).then((res) => {
      this.setState({
        disableAdd: false,
        showAddModal: false,
        showCheckModal: true,
        checkData: res.data.rowData,
        rec_no: res.data.rows,
        err_no: res.data.errs.length,
      });
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableAdd: true });
    let formData = new FormData();
    formData.append("uploadFile", this.state.actual_file);
    formData.append("file_name", this.state.file_name);
    formData.append("description", this.state.description);
    formData.append("record_year", this.state.record_year);
    formData.append("company_id", cookies.get("transCompany"));
    formData.append("updated_by", cookies.get("email"));
    formData.append("created_by", cookies.get("email"));
    axios
      .post("api/add_upload_adjustment", formData)
      .then((res) => {
        this.props.parentCallback(true);

        if (res.data.errors) {
          this.setState({
            disableAdd: true,
            hasError: true,
            showAddModal: false,
          });

          const element = document.createElement("a");
          const file = new Blob(res.data.errors, {
            type: "text/plain",
          });
          element.href = URL.createObjectURL(file);
          element.download = this.state.file_name + "_errors.txt";
          document.body.appendChild(element);
          alert("Failed to upload file see downloaded .txt for reference");
          element.click();
        } else {
          this.setState({
            disableAdd: false,
            hasError: false,
            showAddModal: false,
            showCheckModal: false,
            showSuccessModal: true,
            actual_file: null,
            file_name: null,
          });
        }
        // window.location.reload();
      })
      .catch((err) => {
        this.setState({ disableAdd: false, hasError: true });
      });
  };

  handleChange = (file) => {
    this.setState({ actual_file: file, file_name: file.name });
  };

  ErrCancel = (e) => {
    e.preventDefault();
    this.setState({
      disableAdd: false,
      showAddModal: false,
      showCheckModal: false,
      showSuccessModal: false,
      hasError: false,
      actual_file: null,
      file_name: null,
    });
    this.props.parentCallback(true);
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-primary btn-sm float-right ml-2"
          title="Upload YTD Adjustment"
          onClick={this.handleshowAddModal}
        >
          <CloudUpload /> Upload YTD Adjustment
        </button>
        <Modal
          size="md"
          show={this.state.showAddModal}
          onHide={() =>
            this.setState({ showAddModal: !this.state.showAddModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Upload YTD Adjustment</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  YTD Adjustment Upload Failed
                </div>
              </div>
            </div>
            <form onSubmit={this.handleCheck} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Year</label>
                  <Select
                    placeholder="Select YTD Year"
                    options={this.props.yearDD}
                    onChange={(e) => {
                      this.setState({ record_year: e.value });
                    }}
                    isSearchable
                    required
                  />
                  <input
                    className="form-control hidden hidden-require"
                    type="text"
                    value={this.state.record_year}
                    autoComplete="off"
                    required
                  />
                </div>
                <div className="form-group col-md-12 col-sm-12">
                  <label>Description</label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => {
                      this.setState({
                        description: e.target.value,
                      });
                    }}
                    required
                  />
                </div>
                <div className="form-group col-md-12 col-sm-12">
                  {/* <label>YTD Adjustment File</label>
                  <input
                    type="file"
                    className="form-control"
                    accept=".xlsx,.xls"
                    required
                    onChange={(e) =>
                      this.setState({
                        actual_file: e.target.files[0],
                        file_name: e.target.files[0].name,
                      })
                    }
                  /> */}

                  <FileUploader
                    multiple={false}
                    handleChange={this.handleChange}
                    types={["XLSX"]}
                    classes="dropzone drop_area"
                  />
                  {this.state.actual_file ? (
                    <div
                      className="alert alert-success font-weight-bold"
                      role="alert"
                    >
                      Uploaded File name: {this.state.file_name}
                    </div>
                  ) : (
                    <div className="alert alert-danger" role="alert">
                      No Files Uploaded
                    </div>
                  )}
                </div>
              </div>
              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableAdd}
                >
                  Proceed
                </button>
                <button
                  onClick={this.handleshowAddModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          size="xl"
          show={this.state.showCheckModal}
          backdrop="static"
          onHide={() =>
            this.setState({ showCheckModal: !this.state.showCheckModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Upload YTD Adjustment: Checking</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="alert alert-info">
                  <strong>File:</strong> {this.state.file_name}
                  <br />
                  <strong>Total Records:</strong> {this.state.rec_no}
                  <br />
                  <strong>Total Errors:</strong> {this.state.err_no}
                  <br />
                </div>
              </div>
            </div>
            <div class="table-responsive mb-10">
              <table class="table table-xs table-bordered mb-0">
                <thead className="thead-secondary">
                  <tr className="text-center">
                    <th>#</th>
                    <th className="text-nowrap">Employee #</th>
                    <th>Employee Name</th>
                    <th>Basic</th>
                    <th className="text-nowrap">De Minimis</th>
                    <th className="text-nowrap">
                      O.Earnings
                      <br />
                      (Tax Exempt)
                    </th>
                    <th>O.Earnings</th>
                    <th>13th Month Pay</th>
                    <th>SSS Premium</th>
                    <th>SSS Provident</th>
                    <th>PhilHealth</th>
                    <th>PAGIBIG</th>
                    <th>O.Deductions</th>
                    <th>WH Tax</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.checkData.map((row) => (
                    <tr key={row.number}>
                      <td>{row.number}</td>
                      <td className={row.err_emp_no == 1 ? "bg-danger" : ""}>
                        {row.emp_no}
                      </td>
                      <td>{row.name}</td>
                      <td className={row.err_basic == 1 ? "bg-danger" : ""}>
                        {row.basic}
                      </td>
                      <td className={row.err_deminimis == 1 ? "bg-danger" : ""}>
                        {row.deminimis}
                      </td>
                      <td
                        className={row.err_earning_nt == 1 ? "bg-danger" : ""}
                      >
                        {row.earning_nt}
                      </td>
                      <td className={row.err_earning == 1 ? "bg-danger" : ""}>
                        {row.earning}
                      </td>
                      <td
                        className={row.err_t_month_pay == 1 ? "bg-danger" : ""}
                      >
                        {row.t_month_pay}
                      </td>
                      <td
                        className={row.err_sss_premium == 1 ? "bg-danger" : ""}
                      >
                        {row.sss_premium}
                      </td>
                      <td
                        className={
                          row.err_sss_provident == 1 ? "bg-danger" : ""
                        }
                      >
                        {row.sss_provident}
                      </td>
                      <td
                        className={row.err_philhealth == 1 ? "bg-danger" : ""}
                      >
                        {row.philhealth}
                      </td>
                      <td className={row.err_pagibig == 1 ? "bg-danger" : ""}>
                        {row.pagibig}
                      </td>
                      <td className={row.err_deduction == 1 ? "bg-danger" : ""}>
                        {row.deduction}
                      </td>
                      <td className={row.err_wh_tax == 1 ? "bg-danger" : ""}>
                        {row.wh_tax}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {this.state.err_no > 0 ? (
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="alert alert-danger">
                    {this.state.err_no} Invalid record(s) found, please correct
                    the data and re-upload
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.err_no > 0 ? (
              <div className="float-right">
                <button
                  onClick={this.ErrCancel}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div className="float-right">
                <button
                  onClick={this.handleSubmit}
                  className="btn btn-primary btn-sm mr-2"
                  type="button"
                  disabled={this.state.disableAdd}
                >
                  Save
                </button>
                <button
                  onClick={this.handleshowCheckModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            )}
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          show={this.state.showSuccessModal}
          backdrop="static"
          onHide={() =>
            this.setState({ showSuccessModal: !this.state.showSuccessModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Upload YTD Adjustment: Successful</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="alert alert-success">
                  <strong>Import Result</strong>
                  <br />
                  <strong>Total Records:</strong> {this.state.rec_no}
                  <br />
                  <strong>Total Errors:</strong> {this.state.err_no}
                  <br />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="float-right">
              <button
                onClick={() =>
                  this.setState({
                    showSuccessModal: !this.state.showSuccessModal,
                  })
                }
                className="btn btn-danger btn-sm"
                type="button"
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
